export default function Machines_C_5 (number = 1) {
  return {
    name: '原油萃取站',
    icon: '/static/img/machines/c5.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_C/Machines_C_5.js